<template>
    <div v-if="autoImportConfigsFailed.length > 0" class="auto-import-configs">
      <v-menu bottom left offset-y origin="top left" :close-on-content-click="false" max-width="280">
        <template v-slot:activator="{ attrs, on }">
          <v-tooltip top>
            <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
              <v-btn
                class="ml-1"
                min-width="0"
                text
                v-bind="{ ...attrs, ...attrsTooltip }"
                v-on="{ ...on, ...onTooltip }"
              >
                <v-badge
                  :content="autoImportConfigsFailed.length"
                  :value="autoImportConfigsFailed.length > 0"
                  color="error"
                  bordered
                  offset-x="10"
                  offset-y="10"
                  size="small"
                >
                  <v-icon size="24">mdi-alert-circle</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>{{ $t("AutoImportConfigsFailed") }}</span>
          </v-tooltip>
        </template>
        <v-list dense class="pa-0">
          <v-list-item dense class="error lighten-5 py-1">
            <v-list-item-content>
              <v-list-item-title class="subtitle-2">
                <v-icon small left color="error">mdi-alert-circle</v-icon>
                {{ $t("AutoImportConfigsFailed") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <template v-if="autoImportConfigsFailed.length > 0">
            <v-list-item dense v-for="config in autoImportConfigsFailed" :key="config.id" class="py-1">
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ config.ContentTypeName }}</v-list-item-title>
                <v-list-item-subtitle class="caption">{{ getServiceName(config.ServiceID) }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="ma-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="reactivateAutoImportConfigFailed(config.Id)"
                      :loading="loading"
                      color="primary"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("ReactivateAutoImportConfig") }}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item v-else dense class="py-1">
            <v-list-item-content>
              <v-list-item-title class="caption text-center">{{ $t("NoFailedConfigurations") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </template>

  <script>
import ContentTypeService from '@/services/ContentTypeService';
export default {
    name: 'AutoImportConfigsFailed',
    data() {
        return {
            autoImportConfigsFailed: [],
            loading: false
        };
    },
    methods: {
        loadAutoImportConfigsFailed() {
            this.loading = true;
            ContentTypeService.getAutoImportConfigsFailed().then((response) => {
                this.autoImportConfigsFailed = response;
                this.loading = false;
            }).catch(() => {
                this.autoImportConfigsFailed = [];
                this.loading = false;
            });
        },
        reactivateAutoImportConfigFailed(autoImportconfigId) {
            this.loading = true;
            ContentTypeService.reactivateAutoImportConfigFailed(autoImportconfigId).then(() => {
                this.loadAutoImportConfigsFailed();
            }).catch(() => {
                this.loading = false;
            });
        },
        getServiceName(serviceId) {
            switch (serviceId) {
            case 13:
                return 'OneDrive';
            case 14:
                return 'Email';
            case 15:
                return 'FileSystem';
            case 20:
                return 'EmailOffice365';
            case 21:
                return 'DocOffice';
            }
        }
    },
    mounted() {
        this.loadAutoImportConfigsFailed();
    },
};
  </script>

  <style scoped>
  .auto-import-configs .v-badge__badge {
    font-size: 10px;
    height: 18px;
    min-width: 18px;
    padding: 2px 4px;
  }
  </style>